(function () {
  let slideIndex = 1;
  let isMobile = window.innerWidth <= 768;

  function handleResize() {
    let wasMobile = isMobile;
    isMobile = window.innerWidth <= 768;
    if (!isMobile) {
      //in desktop hide all relevant slides
      hideSlides();
    } else if (!wasMobile && isMobile) {
      //switched from desktop to mobile, start slideshow
      showSlides((slideIndex = 1));
    }
  }

  function plusSlides(n) {
    showSlides((slideIndex += n));
  }

  function hideSlides() {
    let slides = document.getElementsByClassName("ique-mobile-slide");
    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none"; // Hide all slides
    }
  }

  function showSlides(n) {
    let i;
    let slides = document.getElementsByClassName("ique-mobile-slide");

    if (n > slides.length) {
      slideIndex = 1;
    }
    if (n < 1) {
      slideIndex = slides.length;
    }

    for (i = 0; i < slides.length; i++) {
      slides[i].style.display = "none"; // Hide all slides
    }

    // Apply the animation and show active slide
    slides[slideIndex - 1].style.animation = "fadeIn 1s ease-in-out";
    slides[slideIndex - 1].style.display = "block";
  }

  if (isMobile) {
    console.log("showslides on startup");
    showSlides(slideIndex);
  }

  //automatically rotate slide every 4 seconds
  setInterval(function () {
    if (isMobile) {
      plusSlides(1, true);
    }
  }, 4000);

  window.addEventListener("resize", function () {
    handleResize();
  });
})();
